import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { ESignatureErrand } from '../../model/esignature-errand';
import { EsignatureErrandService } from '../../service/data/esignature-errand.service';
import { ESignatureErrandCommandHandlerResolver } from '../../service/command/esignature-errand-command-handler-resolver.service';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { standardCommand } from '../../../core/model/command';
import { OpenESignatureDocumentCommandHandler } from '../../service/command/open-esignature-document-command-handler.service';
import { esignatureErrandCommand } from '../../command/esignature-errand.command';
import { ActivatedRoute } from '@angular/router';
import { EsignatureErrandStatus } from '../../model/const/enums';
import { CancelESignErrandCommandHandler } from '../../service/command/cancel-esign-errand-command-handler.service';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';

@Component({
    selector: 'app-esignature-errand-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [ESignatureErrandCommandHandlerResolver, OpenESignatureDocumentCommandHandler, CancelESignErrandCommandHandler],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EsignatureErrandManagerComponent extends PagedObjectManagerComponent<ESignatureErrand> {
  constructor(
    cdf: ColumnDefinitionFactory,
    private _dataEsignatureErrandService: EsignatureErrandService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: ESignatureErrandCommandHandlerResolver,
    activatedRoute?: ActivatedRoute
  ) {
    super(_dataEsignatureErrandService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = [
      cdf.create('COMMON.STATUS', 'statusText', { allowSort: this }),
      cdf.createDate('ESIGNATURE.EXPIRATION_DATE', 'expirationDate'),
      cdf.create('ESIGNATURE.DESCRIPTION', 'errandDescription'),
      cdf.create('ESIGNATURE.SIGNATORIES', 'signatoriesNames', { allowSort: this }),
      cdf.createDateTime('COMMON.CREATED_DATE', 'createdAt'),
      cdf.createDateTime('ESIGNATURE.COMPLETED_AT', 'completedAt'),
      cdf.createDateTime('ESIGNATURE.CANCELLED_AT', 'cancelledAt', ColumnVisibility.optional),
      cdf.create('COMMON.COMPANY', 'companyNumberAndName', {
        visibility: ColumnVisibility.optional,
        serverSideSortBinding: 'companyNumber',
      }),
    ];

    this.contextMenuDefinition = [
      new MenuItemDefinition('LEASE_AGREEMENT.COMMAND.SHOW_DOCUMENTS', esignatureErrandCommand.openESignatureDocument),
      new MenuItemDefinition('ESIGNATURE.CANCEL_ERRAND', esignatureErrandCommand.cancelESignatureErrand),
      new MenuItemDefinition('EDIT_BTN', standardCommand.edit),
    ];

    // this.menuDefinition = [
    //   new MenuItemDefinition('COMMON.EXCEL_EXPORT', rentalObjectCommand.export)
    // ];

    if (activatedRoute) {
      this.AddSubscription(
        activatedRoute.queryParamMap.subscribe(map => {
          if (map.has('errandstatus')) {
            const param = map.get('errandstatus');
            if (param) {
              const eStatus = EsignatureErrandStatus[param[0].toUpperCase() + param.substring(1)];
              if (eStatus) {
                this._errandStatus = eStatus;
              }
            }
          }
        })
      );
    }

    this.title = 'DASHBOARD.MENU.ESIGNATURE_ERRANDS';
    this.preferencesKey = 'rent.esignature-errand.list';
  }

  private _errandStatus: EsignatureErrandStatus;

  ngOnInit() {
    this.AddSubscription(
      this._dataEsignatureErrandService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        const companies = definition.companies.map(x => {
          return { caption: x.toString(), value: x.id };
        });
        companies.splice(0, 0, { caption: 'ALL_TEXT', value: '' });
        const filterSetFromUrl = this._errandStatus;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'LEASE_AGREEMENT.STATUS',
            'status',
            filterSetFromUrl ? this._errandStatus : definition.status,
            [
              { caption: 'ALL_TEXT', value: 0 },
              { caption: 'CONST.ESIGNATURE_STATUS_PENDING', value: EsignatureErrandStatus.AwaitingSignature },
              { caption: 'CONST.ESIGNATURE_STATUS_PENDING_LANDLORD', value: EsignatureErrandStatus.AwaitingCompanyRepresentativeSignature },
              { caption: 'CONST.ESIGNATURE_STATUS_CANCELLED', value: EsignatureErrandStatus.Cancelled },
              { caption: 'CONST.ESIGNATURE_STATUS_EXPIRED', value: EsignatureErrandStatus.Expired },
              { caption: 'CONST.ESIGNATURE_STATUS_COMPLETED', value: EsignatureErrandStatus.Signed },
            ],
            definition.selectedFields.includes('status')
          ),
          new FilterDefinitionItem(
            'COMPANY.LIST_HEADER',
            'company',
            filterSetFromUrl ? '' : definition.company,
            companies,
            definition.selectedFields.includes('company')
          ),
          new FilterDefinitionItem(
            'ESIGNATURE.DESCRIPTION',
            'errandDescription',
            filterSetFromUrl ? '' : definition.errandDescription,
            null,
            definition.selectedFields.includes('errandDescription')
          ),
          new FilterDefinitionItem(
            'ESIGNATURE.FILTER.SIGNATORY_NAME',
            'signatoryName',
            filterSetFromUrl ? '' : definition.signatoryName,
            null,
            definition.selectedFields.includes('errandDescription')
          ),
          new FilterDefinitionItem(
            'ESIGNATURE.FILTER.SIGNATORY_EMAIL',
            'signatoryEmail',
            filterSetFromUrl ? '' : definition.signatoryEmail,
            null,
            definition.selectedFields.includes('errandDescription')
          ),
          new FilterDefinitionItem(
            'ESIGNATURE.FILTER.SIGNATORY_CIVIC_NO',
            'signatoryCivicNo',
            filterSetFromUrl ? '' : definition.signatoryCivicNo,
            null,
            definition.selectedFields.includes('signatoryCivicNo')
          ),
        ];
      })
    );
  }
}
